import { createUseStyles } from "react-jss";
import { getSpacing } from "../../../theme/Mixins";

export default createUseStyles({
    choices: {
        alignItems: "center",
        composes: "net-promoter__choices",
        display: "flex",
        justifyContent: "space-between",
        margin: ({theme}) => [[getSpacing(theme, 0, theme.QuestionSpacing?.WithinComponents), -3]],
    },
    dynamicChoices: {
        flexDirection: "column",
        margin: 0,
    },
    labels: {
        composes: "net-promoter__labels",
        display: "flex",
        justifyContent: "space-between",
        margin: [[20, 0]],
    },
    dynamicLabels: {
        display: "none",
    },
    label: {
        composes: "net-promoter__label",
    },
    mobileLabel: {
        textAlign: "center",
        display: "none",
    },
    dynamicMobileLabel: {
        display: "block",
    },
    /** First focus target when invalid so global InputFocusRenderer does not land on the first score. */
    validationFocusAnchor: {
        composes: "sr-only",
        position: "absolute",
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        border: 0,
    },
});
